<template>
  <div class="container">
    <div class="mx-auto mb-5">
      <div id="compo" class="shadow">
        <div class="border-cr"></div>
        <vue-draggable-resizable
          :w="100"
          :h="100"
          :X="100"
          :y="100"
          :parent="true"
          :debug="true"
          :min-width="mw"
          :min-height="mh"
          @dragging="onDrag"
          @resizing="onResize"
          :is-conflict-check="false"
          :snap="true"
          @refLineParams="getRefLineParams"
          :lock-aspect-ratio="true"
          class="test1"
        >
          <img src="../assets/logo.png" alt />
        </vue-draggable-resizable>
        <vue-draggable-resizable
          :w="100"
          :h="100"
          :X="200"
          :y="210"
          :debug="true"
          :parent="true"
          :min-width="mw"
          :min-height="mh"
          @dragging="onDrag"
          @resizing="onResize"
          :is-conflict-check="false"
          :snap="true"
          :snapTolerance="10"
          @refLineParams="getRefLineParams"
          class="test2"
        >
          <label for="image-custom">
            <img src="../assets/logo.png" alt />
            <input type="file" hidden id="image-custom" />
          </label>
          <div class="mask"></div>
        </vue-draggable-resizable>
        <vue-draggable-resizable
          :w="100"
          :h="100"
          :X="300"
          :y="300"
          :debug="true"
          :parent="true"
          :min-width="mw"
          :min-height="mh"
          @dragging="onDrag"
          @resizing="onResize"
          :is-conflict-check="true"
          :snap="true"
          :snapTolerance="10"
          @refLineParams="getRefLineParams"
          class="test3"
        >
          <img src="../assets/logo.png" alt />
        </vue-draggable-resizable>
        <span
          class="ref-line v-line"
          v-for="(item, index) in vLine"
          :key="`v-line-${index}`"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength,
          }"
        />
        <span
          class="ref-line h-line"
          v-for="(item, index) in hLine"
          :key="`h-line-${index}`"
          v-show="item.display"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength,
          }"
        />
      </div>
    </div>
    <div class="flex my-5 items-center justify-center">
      <button @click="createImg" class="btn btn-blue">Save</button>
      <button class="btn btn-blue">Download</button>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from '@/components/Draggable.vue'
import * as htmlToImage from 'html-to-image'
const item = {
  w: 400,
  h: 400,
  mw: 10,
  mh: 10,
  content: '<img alt="Vue logo" src="/img/logo.82b9c7a5.png" />',
  // content: '<img src="/descarga.png">'
}
export default {
  name: 'Home',
  components: {
    VueDraggableResizable,
  },
  data: () => ({
    elements: [],
    vLine: [],
    hLine: [],
    items: [],
    x: 100,
    y: 100,
    w: 400,
    h: 400,
    mw: 10,
    mh: 10,
    content: '<img alt="Vue logo" src="/img/logo.82b9c7a5.png" />',
  }),
  created() {
    this.items.push(item)
  },
  methods: {
    getRefLineParams(params) {
      const { vLine, hLine } = params
      this.vLine = vLine
      this.hLine = hLine
    },
    createImg() {
      const scale = 2
      let domNode = document.getElementById('compo')
      htmlToImage
        .toPng(domNode, {
          width: domNode.offsetWidth * scale,
          height: domNode.offsetHeight * scale,
          style: {
            transform: 'scale(' + scale + ')',
            transformOrigin: 'top left',
          },
        })

        .then(function (dataUrl) {
          var link = document.createElement('a')
          link.download = 'my-image-name.jpeg'
          link.href = dataUrl
          link.click()
        })
    },
    onResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.w = width
      this.h = height
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
    },
  },
}
</script>
<style lang="scss">
</style>
